<template>
	<svg
		width="24"
		height="24"
		viewBox="0 0 24 24"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<rect x="-1.52588e-05" width="24" height="24" rx="3" fill="#252122" />
		<rect
			x="9.39131"
			y="14.6087"
			width="5.21739"
			height="5.21739"
			rx="1"
			transform="rotate(-90 9.39131 14.6087)"
			fill="white"
		/>
	</svg>
</template>

<script>
export default {
	name: "DiceNeutral",
};
</script>
